import React from "react";

import { css } from "@emotion/css";

import { usePatientIdFromURL } from "@/hooks/usePatientIdFromURL.ts";
import { useStyles } from "@/hooks/useStyles.ts";
import { AlertSettings } from "@/pages/patient-settings/alert-settings/AlertSettings.tsx";
import { CGMThresholdSettings } from "@/pages/patient-settings/CGMThresholdSettings.tsx";
import { Queries } from "@/queries/Queries.ts";
import { Theme } from "@/theme/CreateTheme.ts";
import { Loader } from "@/uiKit/atoms/Loader.tsx";

import { BGMThresholdSettings } from "./BGMThresholdSettings.tsx";

export const PatientSettings: React.FC = () => {
  const styles = useStyles(makeStyles);
  const patientId = usePatientIdFromURL();
  const condition = Queries.condition.useCondition(patientId);
  const parameters = Queries.diabetes.useParameters(patientId);

  if (!parameters.data) {
    return (
      <div className={styles.loading}>
        <Loader size="L" />
      </div>
    );
  }

  return (
    <div className={styles.container}>
      {parameters.data.type === "BGM" && (
        <BGMThresholdSettings
          parameters={parameters.data.parameters}
          gestational={condition.diabetesType === "gestational"}
        />
      )}
      <div className={styles.content}>
        {parameters.data.type === "CGM" && <CGMThresholdSettings parameters={parameters.data.parameters} />}
        <AlertSettings />
      </div>
    </div>
  );
};

const makeStyles = (theme: Theme) => ({
  container: css`
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: ${theme.spacing(12)};
  `,
  content: css`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: ${theme.spacing(8)};
  `,
  loading: css`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  `,
});
